__turbopack_context__.v({
  "categoryDetailIntro": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__categoryDetailIntro",
  "ctaGroup": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__ctaGroup",
  "fade-in": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__fade-in",
  "headlineWrap": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__headlineWrap",
  "heroImage": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__heroImage",
  "imageColumn": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__imageColumn",
  "intro-in": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__intro-in",
  "textBlock": "BlockCategoryDetailIntro-module-scss-module__4mZ1iq__textBlock",
});
